import { cn } from '@workspace/ui/lib/utils';
import type React from 'react';

import ProductCardSkeletonFactory from '~/components/ProductCardV3/skeletons/ProductCardSkeletonFactory';
import ProductCardM from '~/components/ProductCardV3/variants/ProductCardM/ProductCardM';
import { useGlobal } from '~/hooks/useGlobal';
import type { Category } from '~/stores/CategoriesStore';

import { CategoryBlockHeader } from './shared/CategoryBlockHeader';

interface ProductsGridMultirowProps
  extends Omit<React.ComponentPropsWithoutRef<'div'>, 'children'> {
  category: Category;
}

export const ProductsGridMultirow: React.FC<ProductsGridMultirowProps> = ({
  category,
  className,
  ...props
}) => {
  const { isMobile } = useGlobal();

  if (!category.products.length && category.productsRequest.isFulfilled) {
    return null;
  }

  if (!category.subcategory.length) {
    return null;
  }

  const products = category.products.slice(0, isMobile ? 10 : 12);

  if (products.length === 0) {
    return (
      <div className="flex gap-4 *:w-[88px] *:shrink-0 md:*:w-[227px]">
        {Array.from({ length: 4 }, (_, i) => (
          <ProductCardSkeletonFactory key={`skeleton-${i}`} variant="m" />
        ))}
      </div>
    );
  }

  return (
    <div {...props} className={cn('flex flex-col gap-6', className)}>
      <CategoryBlockHeader category={category} />
      <div
        {...props}
        className={cn(
          'grid grid-cols-2 gap-2 md:grid-cols-4 md:gap-4',
          className,
        )}
      >
        {products.map((product) => (
          <ProductCardM
            key={product.id}
            product={product}
            className="w-full!"
          />
        ))}
      </div>
    </div>
  );
};
